import React, { useState, useEffect, useContext } from "react";
import { Row, Col, Alert } from "reactstrap";
import PromoItem from "../../components/promoItem";
import UserWelcome from "../../components/userWelcome";
import UserStatementsGraph from "../../components/userStatementsGraph";
import SubuserStatementsGraph from "../../components/subuserStatementsGraph";
import { StateContext } from "../../utils/context";
import UserHelpScoutBeacon from "../../components/userHelpScoutBeacon";
import SubUserHelpScoutBeacon from "../../components/subuserHelpScoutBeacon";
import ZapierBot from "../../components/zapierBot";


const Dashboard = () => {
  const {currentUser} = useContext(StateContext);
  // // const [promoFeedbackCount, setPromoFeedbackCount] = useState(0);
  // // const [promoDownloadCount, setPromoDownloadCount] = useState(0);

  // // useEffect(() => {
  // //   if (currentUser) {
  // //     setPromoFeedbackCount(currentUser.promo_feedback_count);
  // //     setPromoDownloadCount(currentUser.promo_download_count);
  // //   }
  // // }, [currentUser]);

  return (
    <>
      {/* <Row>
        <Col>
          <UserWelcome />
        </Col>
      </Row> */}

      {
        (currentUser && currentUser.is_blacklisted) &&
        <>
          <Alert color="danger">
            Your account has been blacklisted after review as we have found that the information associated with your account is linked with one of the internationally blacklisted users in our system. Consequently, we have disabled the Distribution feature for your account.
          </Alert>
        </>
      }

      <Row>
        <Col>
          {/* {
            (currentUser && currentUser.is_sub_user) && 
            <>
              <SubuserStatementsGraph />
              <SubUserHelpScoutBeacon />
            </>
          } */}
          {
            (currentUser && !currentUser.is_sub_user) && 
            <>
              {/* <UserStatementsGraph /> */}
              <UserHelpScoutBeacon />
            </>
          }
        </Col>
      </Row>
      {/* <Row>
        <PromoItem
          itemIcon="ti-pie-chart"
          itemHeading="Promo download count"
          itemSubHeading="Total downloads"
          itemCount={promoDownloadCount}
          cardBg="#707cd2"
        />
        <PromoItem
          id="2"
          itemIcon="icon-cloud-download"
          itemHeading="Promo feedback count"
          itemSubHeading="Total feedbacks"
          itemCount={promoFeedbackCount}
          cardBg="#ff5050"
        />
      </Row> */}
      {
        (currentUser.is_premium_user || currentUser.is_employee_account) && <ZapierBot />
      }
    </>
  );
};

export default Dashboard;
